import DownloadButton from "../DownloadButton";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";
import "../../styles/components/transactionPrintLayouts/IncomingInspectionInvoiceLayout.css";

export const IncomingInspectionInvoiceLayout = ({
  headDetails,
  companyData,
  itemDetails,
  invoiceTableData,
  headFields,
}) => {
  const organizationData =
    JSON.parse(localStorage.getItem("organisation")) || {};

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return `${day}-${month}-${d.getFullYear()}`;
  };

  const rows = Array.isArray(itemDetails) ? itemDetails : [];
  const headingFields = Array.isArray(invoiceTableData?.headings)
    ? invoiceTableData.headings
    : [];
  const transactionHeadFields = Array.isArray(headFields) ? headFields : [];

  const getHeadField = (details, ...keys) => {
    for (const key of keys) {
      const value = details?.[key];
      if (value !== null && value !== undefined && value !== "") return value;
    }
    return "";
  };

  const getField = (row, ...keys) => {
    for (const k of keys) {
      const val = row?.[k];
      if (val !== null && val !== undefined && val !== "") return val;
    }
    return "";
  };

  const normalizeFieldName = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const findHeadingFieldName = (...possibleNames) => {
    const normalizedCandidates = possibleNames.map((name) =>
      normalizeFieldName(name),
    );
    const matched = headingFields.find((field) => {
      const normalizedFieldName = normalizeFieldName(field?.field_name);
      const normalizedDisplayName = normalizeFieldName(field?.display_name);
      return normalizedCandidates.some(
        (candidate) =>
          candidate &&
          (candidate === normalizedFieldName ||
            candidate === normalizedDisplayName),
      );
    });

    return matched?.field_name;
  };

  const displayRows = rows;
  const inspectionNumberField = transactionHeadFields.find(
    (field) => normalizeFieldName(field?.field_name) === "tranno",
  );
  const inspectionNumberLabel =
    inspectionNumberField?.display_name || inspectionNumberField?.title;

  const getReadingValue = (row, readingNumber) => {
    const resolvedReadingField = findHeadingFieldName(
      String(readingNumber),
      `value_${readingNumber}`,
      `reading_${readingNumber}`,
      `obv_${readingNumber}`,
      `obs_${readingNumber}`,
      `observation_${readingNumber}`,
    );

    return getField(
      row,
      resolvedReadingField,
      String(readingNumber),
      `value_${readingNumber}`,
      `reading_${readingNumber}`,
      `obv_${readingNumber}`,
      `obs_${readingNumber}`,
    );
  };

  const serialNumberField = findHeadingFieldName(
    "sl_no",
    "si_no",
    "serial_no",
    "serial_number",
    "s_no",
  );
  const parameterField = findHeadingFieldName("parameter", "characteristics");
  const specificationField = findHeadingFieldName(
    "specification",
    "parameter_value",
    "spec",
  );
  const inspectionMethodField = findHeadingFieldName(
    "inspection_method",
    "inspectionmethod",
    "insp_method",
    "inspmethod",
    "method_of_inspection",
    "method",
    "tolerence",
  );

  const acceptanceStateRaw = getHeadField(
    headDetails,
    "acceptance_states",
    "acceptance_state",
    "acceptance_status",
    "grn_incoming_inspection_status",
    "status",
  );

  const normalizedAcceptanceState = String(acceptanceStateRaw || "")
    .toLowerCase()
    .replace(/[_\-]+/g, " ")
    .trim();

  const selectedAcceptanceState = normalizedAcceptanceState.includes("not ok")
    ? "NOT OK"
    : normalizedAcceptanceState.includes("ok")
      ? "OK"
      : "";

  const observationReadingNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="invoice-container incoming-inspection-page-container">
      <div className="incoming-header-grid">
        <div className="incoming-header-company-block">
          <div className="invoice-logo-container incoming-header-logo-container">
            <img
              src={organizationData.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="invoice-logo-content"
            />
          </div>
          <div className="incoming-header-company-text-wrap">
            <h3 className="invoice-company-name incoming-company-name">
              {organizationData.name || "N/A"}
            </h3>
            {organizationData.address && (
              <p className="invoice-company-address incoming-company-address">
                {organizationData.address}
              </p>
            )}
          </div>
        </div>

        <div className="incoming-header-title-block">
          <h2 className="incoming-header-title">Incoming Inspection Report</h2>
        </div>

        <div className="incoming-header-ref-block">
          <div className="incoming-header-ref-row">
            <strong className="incoming-header-ref-label">REF. NO.:</strong>
            <span>
              {getHeadField(
                headDetails,
                "ref_no",
                "ref_number",
                "reference_no",
              ) || "FP/F/QA/02"}
            </span>
          </div>
          <div className="incoming-header-ref-row">
            <strong className="incoming-header-ref-label">REV. NO.:</strong>
            <span>{getHeadField(headDetails, "rev_no", "revision_no")}</span>
          </div>
          <div className="incoming-header-ref-row">
            <strong className="incoming-header-ref-label">REV. DATE:</strong>
            <span>
              {getHeadField(headDetails, "rev_date", "revision_date")
                ? formatDate(
                    getHeadField(headDetails, "rev_date", "revision_date"),
                  )
                : ""}
            </span>
          </div>
        </div>
      </div>

      <div className="incoming-meta-row incoming-meta-row-3 incoming-meta-row-inline">
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">Date:</h4>
          <span className="invoice-section-text report-header-text">
            {formatDate(
              getHeadField(
                headDetails,
                "date",
                "created_at",
                "inspection_date",
                "createdAt",
              ),
            )}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">
            Work Order No.:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(headDetails, "workorder_no", "wo_no")}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell incoming-no-right-border">
          <h4 className="invoice-section-title incoming-meta-title">
            Supplier Name:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "supplier_name",
              "party_name",
              "company_name",
              "supplier",
              "vendor_name",
              "customer_name",
              "party",
            ) ||
              getHeadField(
                companyData,
                "company_name",
                "supplier_name",
                "party_name",
              )}
          </span>
        </div>
      </div>

      <div className="incoming-meta-row incoming-meta-row-3">
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">
            Part Name:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "part_name",
              "part",
              "product_name",
              "item_name",
              "product_desc",
              "description",
              "item_description",
            )}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">
            Invoice Qty.:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "invoice_qty",
              "quantity",
              "qty",
              "total_qty",
              "invoice_quantity",
            )}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell incoming-no-right-border">
          <h4 className="invoice-section-title incoming-meta-title">
            Sample Qty.:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "sample_qty",
              "sample_quantity",
              "sampleQty",
            )}
          </span>
        </div>
      </div>

      <div className="incoming-meta-row incoming-meta-row-3 incoming-meta-row-inline">
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">
            {inspectionNumberLabel}:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(headDetails, "tran_no")}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell">
          <h4 className="invoice-section-title incoming-meta-title">
            DC or Invoice No.:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "dc_invoice_no",
              "invoice_no",
              "dc_no",
              "reference_no",
              "ref_no",
            )}
          </span>
        </div>
        <div className="report-header-section incoming-meta-cell incoming-no-right-border">
          <h4 className="invoice-section-title incoming-meta-title">
            Part No.:
          </h4>
          <span className="invoice-section-text report-header-text">
            {getHeadField(
              headDetails,
              "part_no",
              "part_number",
              "product_desc",
              "item_code",
            )}
          </span>
        </div>
      </div>

      <div className="invoice-overflow-x-scroll">
        <table className="invoice-table">
          <thead className="invoice-thead">
            <tr>
              <th className="invoice-th incoming-first-col" rowSpan={2}>
                Si. No.
              </th>
              <th className="invoice-th" rowSpan={2}>
                Parameter
              </th>
              <th className="invoice-th" rowSpan={2}>
                Specification
              </th>
              <th className="invoice-th" rowSpan={2}>
                Inspection Method
              </th>
              <th className="invoice-th" colSpan={10}>
                OBSERVATION READING
              </th>
            </tr>
            <tr>
              {observationReadingNumbers.map((readingNumber, index) => (
                <th
                  key={readingNumber}
                  className={`invoice-th ${
                    index === observationReadingNumbers.length - 1
                      ? "incoming-no-right-border"
                      : ""
                  }`}
                >
                  {readingNumber}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayRows.map((row, idx) => (
              <tr key={idx}>
                <td className="invoice-td incoming-first-col">
                  {getField(
                    row,
                    serialNumberField,
                    "sl_no",
                    "si_no",
                    "serial_no",
                    "serial_number",
                    "s_no",
                  ) || (row ? idx + 1 : "")}
                </td>
                <td className="invoice-td">
                  {getField(
                    row,
                    parameterField,
                    "parameter",
                    "characteristics",
                  )}
                </td>
                <td className="invoice-td">
                  {getField(
                    row,
                    specificationField,
                    "specification",
                    "parameter_value",
                    "spec",
                  )}
                </td>
                <td className="invoice-td">
                  {getField(
                    row,
                    inspectionMethodField,
                    "inspection_method",
                    "insp_method",
                    "tolerence",
                    "method_of_inspection",
                    "method",
                  )}
                </td>
                {observationReadingNumbers.map((readingNumber, fieldIndex) => (
                  <td
                    key={readingNumber}
                    className={`invoice-td ${
                      fieldIndex === observationReadingNumbers.length - 1
                        ? "incoming-no-right-border"
                        : ""
                    }`}
                  >
                    {getReadingValue(row, readingNumber)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="report-header-grid-container no-top-border">
        <div className="report-left-pane report-states-pane">
          <p className="invoice-note-heading report-notes-heading">
            <strong>ACCEPTANCE STATES:</strong>
          </p>
          <div className="report-status-row">
            <p className="report-summary-label incoming-status-label">
              <strong>{selectedAcceptanceState}</strong>
            </p>
          </div>
        </div>
        <div className="invoice-right-pane">
          <p className="remarks-label">
            <strong>REMARKS:</strong>
          </p>
        </div>
      </div>

      <div className="inspection-footer-grid">
        <div className="signature-box">
          <p className="remarks-label">
            <strong>INSPECTED BY:</strong>{" "}
            {getHeadField(
              headDetails,
              "inspected_by",
              "inspector",
              "checked_by",
              "qc_inspector",
            )}
          </p>
        </div>
        <div className="signature-box incoming-no-left-border">
          <p className="remarks-label">
            <strong>APPROVED BY:</strong>{" "}
            {getHeadField(
              headDetails,
              "approved_by",
              "approvedby",
              "approver",
              "qc_approved_by",
            )}
          </p>
        </div>
      </div>

      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>

      <div className="invoice-buttons incoming-download-buttons">
        <DownloadButton
          tableData={invoiceTableData}
          fileName="incoming-inspection-report"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".incoming-inspection-page-container"
        />
      </div>
    </div>
  );
};
